import "./home.css";
import FirstDiv from "../../components/homepage/firstdiv/FirstDiv";
import SecondDiv from "../../components/homepage/seconddiv/SecondDiv";
import MovingText from "../../components/movingtext/MovingText";
import Footer from "../../components/footer/Footer";



export default function Home() {
    return (
        <div className="home">
            <div className="row">
                <section className="home__firstDiv">
                    <FirstDiv />
                </section>
                <section className="home__secondDiv">
                    <SecondDiv />
                </section>
                <section className="home__thirdDiv">
                    <MovingText />
                    <Footer />
                </section>
            </div>
        </div>
    )
}
